import React from 'react';
import { color, space } from 'styled-system';
import { Page } from 'components/layout';
import { Box, Flex, Container } from 'components/ui';
import styled from 'styled-components/macro';
import { Title } from 'components/ui/Title';
import twitterIcon from 'img/twitter.svg';
import emailIcon from 'img/email.svg';
import { twitterURL, contactEmail} from 'utils/config';

const Hyperlink = styled.a`
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  ${color}
  ${space}
`;

const Content = styled(Flex)`
  align-items: center;

  ${Title} {
    font-size: 35px;
  }

  section {
    margin-bottom: 10px;
    max-width: 800px;
    align-self: center;
  }

  h2 {
    margin-top: 40px;
  }

  h4 {
    font-size: 17px;
    margin-bottom: 8px;
  }

  h5 {
    font-size: 15px;
  }

  hr {
    width: 100%;
    max-width: 800px;
    margin-bottom: 20px;
    border-color: rgba(255, 255, 255, 0.3);
  }

  a {
    color: aquamarine;
  }

  th,
  td {
    border-bottom: 1px solid gray;
  }
`;

const ContactPage = () => {
  return (
    <Page title="Contact" fixedFooter={false}>
      <Container>
        <Content color="copy" column>
          <Title>Contact EulerBeats</Title>

        <section>
        <p>
            <Box display="flex" alignItems="center">
            <Box mr={4}>
              <Hyperlink color="copy" href={twitterURL} target="_blank" rel="noopener noreferrer">
                <img src={twitterIcon} alt="@eulerbeats" width="30px" color="white" />
              </Hyperlink>
            </Box>
            <Box>
              <Hyperlink
                color="copy"
                href={`mailto:${contactEmail}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={emailIcon} alt={contactEmail} width="30px" />
              </Hyperlink>
            </Box>
          </Box>
        </p>
      </section>
        </Content>
      </Container>
    </Page>
  );
};

export default ContactPage;
